<script>
    import { getContext, onMount } from 'svelte';
    import { publishOpenAction } from './openable';
    import CopyButton from '../CopyButton.svelte';
    import PlaygroundHelper from '../scripts/playgroundhelper';
    import FormatHelper from '../scripts/FormatHelper';

    export let photo;
    $: playground = photo ? photo.playground : null;
    $: playgroundTitle = PlaygroundHelper.presentPlayground(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(photo, action);

    /**
     * Set when the item appears because a photo group was split up, to open the photo
     * right away so the photos can be handled one after the other.
     */
    export let autoOpen = false;

    onMount(() => {
        if (!autoOpen) {
            return;
        }

        // Only open it the first time the item is rendered
        photo.autoOpen = false;
        action();
    });

    /**
     * Callback (photo) => () for when a photo has been handled. The updated photo will be passed in.
     *
     * @type Function
     */
    export let photoHandled;

    let getMap = getContext('getMap');

    function photoClosed() {
        if (!photo || !photoHandled) {
            return;
        }

        // Make sure the item was indeed handled
        if (photo.state == 'draft') {
            return;
        }

        // Let the sidebar know that this item should be removed
        photoHandled(photo);
    }

    function action() {
        getMap().openApprovePhotoPopup(photo, photoClosed);
    }

</script>

<p>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a href="#" on:click|preventDefault={action}>Nytt foto: {playgroundTitle}</a>
</p>
<p class="small-line">
    {FormatHelper.dateTime(photo.created)}
</p>
<p class="small-line">
    <i class="far fa-image" />
    {photo._id}<CopyButton text={photo._id} />
</p>

<!--p class="small-line">
    <i class="fas fa-user" />
    {photo.user}<CopyButton text={photo.user} />
</p-->
<style>
    p {
        margin: 0;
        padding: 0;
    }

    p.small-line {
        font-size: 12px;
    }
</style>
